import { ActionReducerMap } from '@ngrx/store';

export * from './notification-prefs.actions';
export * from './notification-prefs.reducer';
export * from './notification-prefs.selectors';
export * from './notification-prefs.effects';

import * as fromNotificationPrefs from './notification-prefs.reducer';

export const reducers: ActionReducerMap<fromNotificationPrefs.NotificationPrefsModuleState> = {
  notificationPrefs: fromNotificationPrefs.reducer
};
